import { render } from "./Businessres.vue?vue&type=template&id=114cfc0c&scoped=true"
import script from "./Businessres.vue?vue&type=script&lang=js"
export * from "./Businessres.vue?vue&type=script&lang=js"

import "./Businessres.vue?vue&type=style&index=0&id=114cfc0c&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src618844026/src/meta-page-client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-114cfc0c"]])

export default __exports__